<template>
  <template v-if="oper == 'elecboardofco1head' && detail == false">
    <!-- 一廠打頭 -->
    <elecBoardOfco1Head></elecBoardOfco1Head>
  </template>
  <template v-else-if="oper == 'elecboardofco1thread' && detail == false">
    <!-- 一廠輾牙 -->
    <elecBoardOfco1Thread></elecBoardOfco1Thread>
  </template>
  <template v-else-if="oper == 'elecboardofco1heat' && detail == false">
    <!-- 一廠熱處理 -->
    <elecBoardOfco1Heat></elecBoardOfco1Heat>
  </template>
  <template v-else-if="oper == 'elecboardofco2head' && detail == false">
    <!-- 二廠打頭 -->
    <elecBoardOfco2Head></elecBoardOfco2Head>
  </template>
  <template v-else-if="oper == 'elecboardofco2thread' && detail == false">
    <!-- 二廠輾牙 -->
    <elecBoardOfco2Thread></elecBoardOfco2Thread>
  </template>
  <template v-else-if="oper == 'elecboardofco2heat' && detail == false">
    <!-- 二廠熱處理 -->
    <elecBoardOfco2Heat></elecBoardOfco2Heat>
  </template>
  <template v-else-if="oper == 'elecboardofco2pk' && detail == false">
    <!-- 二廠包裝 -->
    <elecBoardOfco2Package></elecBoardOfco2Package>
  </template>
  <template v-else-if="oper == 'elecboardofco2cn' && detail == false">
    <!-- 二廠裝櫃 -->
    <elecBoardOfco2Container></elecBoardOfco2Container>
  </template>
  <template v-else-if="detail == true">
    <!-- 機台明細 -->
    <machStatus></machStatus>
  </template>
  <template v-else> 無此頁面 </template>
</template>

<script>
import { useStore } from "vuex";
import {
  computed,
  inject,
  onUnmounted,
  provide,
  ref,
  watch,
} from "@vue/runtime-core";
import elecBoardOfco1Head from "@/components/elecBoard/elecBoardOfco1Head";
import elecBoardOfco1Thread from "@/components/elecBoard/elecBoardOfco1Thread";
import elecBoardOfco1Heat from "@/components/elecBoard/elecBoardOfco1Heat";
import elecBoardOfco2Head from "@/components/elecBoard/elecBoardOfco2Head";
import elecBoardOfco2Thread from "@/components/elecBoard/elecBoardOfco2Thread";
import elecBoardOfco2Heat from "@/components/elecBoard/elecBoardOfco2Heat";
import elecBoardOfco2Package from "@/components/elecBoard/elecBoardOfco2Package";
import elecBoardOfco2Container from "@/components/elecBoard/elecBoardOfco2Container";
import elecBoardPreheating from "@/components/elecBoard/elecBoardPreheating";
import elecBoardHeating from "@/components/elecBoard/elecBoardHeating";
import elecBoardForging from "@/components/elecBoard/elecBoardForging";
import elecBoardAnnealing from "@/components/elecBoard/elecBoardAnnealing";
import elecBoardHeading from "@/components/elecBoard/elecBoardHeading";
import elecBoardThread from "@/components/elecBoard/elecBoardThread";
import elecBoardHeat from "@/components/elecBoard/elecBoardHeat";
import elecBoardPackage from "@/components/elecBoard/elecBoardPackage";
import elecBoardContainer from "@/components/elecBoard/elecBoardContainer";
import machStatus from "@/components/machStatus";
export default {
  components: {
    elecBoardOfco1Head,
    elecBoardOfco1Thread,
    elecBoardOfco1Heat,
    elecBoardOfco2Head,
    elecBoardOfco2Thread,
    elecBoardOfco2Heat,
    elecBoardOfco2Package,
    elecBoardOfco2Container,
    elecBoardPreheating,
    elecBoardHeating,
    elecBoardForging,
    elecBoardAnnealing,
    elecBoardHeading,
    elecBoardThread,
    elecBoardHeat,
    elecBoardPackage,
    elecBoardContainer,
    machStatus,
  },
  setup() {
    const store = useStore();

    //getters
    const loginData = computed(() => store.getters["getLogin/get_loginData"]);
    const sideBarSelect = computed(
      () => store.getters["sideBarTree/get_sideBarSelect"]
    );
    const sideNavPath = computed(
      () => store.getters["sideBarTree/get_sideNavPath"]
    );
    const axiosResult = computed(
      () => store.getters["commonAxios/get_axiosResult"]
    );
    const timeOutId = computed(
      () => store.getters["commonAlert/get_timeOutId"]
    );

    //dispatch
    const methods = {
      axiosAction: async (payload) => {
        await store.dispatch("commonAxios/axiosAction", payload);
      },
    };

    const path = inject("path");
    const site = ref();
    const oper = ref();
    const siteName = ref();
    const operName = ref();
    const deviceName = ref();
    const detail = ref();
    const userArray = ref([]);
    const colCount = ref(0);
    const deviceArray = ref([]);
    const totalDeviceStatus = ref({});
    const deviceData = ref({});
    const tabIndex = ref(0);
    const nowTime = ref("-");
    const queryCounter = ref(0);
    const groupSelect = ref(0);
    const groupDevice = ref({});
    const groupList = ref([]);
    const siteAuditMode = ref(false);

    //function
    //初始化即時數據
    const initRealData = () => {
      deviceName.value = "";
      deviceData.value = {};
      tabIndex.value = 0;
    };
    const setElecboardOper = (oper) => {
      const user = oper.user;
      const device = oper.device;
      userArray.value = [];
      user.forEach((data) => {
        userArray.value.push({
          name: data.name,
          position: data.position,
          image: require("../assets/" + data.image),
        });
      });
      console.log(oper);

      deviceArray.value = [];
      device.forEach((data) => {
        if (
          groupSelect.value == 0 ||
          (groupDevice.value[groupList.value[groupSelect.value - 1]] &&
            groupDevice.value[groupList.value[groupSelect.value - 1]].includes(
              data
            ))
        ) {
          deviceArray.value.push(data);
        }
      });

      colCount.value = 0;
      colCount.value = Math.ceil(deviceArray.value.length / 2);
      console.log(colCount.value);
    };
    const setElecboardStatus = (oper) => {
      const device = oper.device;
      const deviceStatus = {
        H: { color: "var(--main-status-danger-color)", value: 0, text: "異常" },
        M: {
          color: "var(--main-status-maintain-color)",
          value: 0,
          text: "維修",
        },
        I: {
          color: "var(--main-status-short-color)",
          value: 0,
          text: "短寸",
        },
        D: {
          color: "var(--main-status-shunting-color)",
          value: 0,
          text: "調車",
        },
        C: {
          color: "var(--main-status-shunting-color)",
          value: 0,
          text: "換模",
        },
        Q: {
          color: "var(--main-status-warning-color)",
          value: 0,
          text: "待機",
        },
        R: {
          color: "var(--main-status-success-color)",
          value: 0,
          text: "運作",
        },
        S: { color: "var(--main-status-stop-color)", value: 0, text: "離線" },
        "-": {
          color: "var(--main-status-stop-color)",
          value: deviceArray.value.length,
          text: "未導入",
        },
      };
      deviceArray.value.forEach((data) => {
        if (deviceData.value[data]) {
          if (deviceData.value[data].status == "") {
            deviceData.value[data].status = "S";
          }
          deviceStatus["-"].value -= 1;
          deviceStatus[deviceData.value[data].status].value += 1;
        }
      });
      totalDeviceStatus.value = deviceStatus;
      // console.log(totalDeviceStatus.value);
    };

    const setSessionItems = () => {
      sessionStorage.setItem("mes-elecBoard-deviceName", deviceName.value);
      sessionStorage.setItem("mes-elecBoard-detail", detail.value);
      sessionStorage.setItem("mes-elecBoard-tabIndex", tabIndex.value);
    };
    window.addEventListener("beforeunload", setSessionItems);

    const getNowTime = () => {
      let Today = new Date();
      nowTime.value =
        Today.getFullYear() +
        "-" +
        String(Today.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(Today.getDate()).padStart(2, "0") +
        " " +
        String(Today.getHours()).padStart(2, "0") +
        ":" +
        String(Today.getMinutes()).padStart(2, "0") +
        ":" +
        String(Today.getSeconds()).padStart(2, "0");
    };
    const clearTimer = () => {
      var highestIntervalId = setInterval(";");
      for (var i = 0; i < highestIntervalId; i++) {
        if (i == timeOutId.value) {
          continue;
        }
        //清除所有計時資料
        clearInterval(i);
      }
    };
    const getMachineData = () => {
      clearTimer();
      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = "elecboard";
      params["methods"] = "GET";
      params["whichFunction"] = "MainQuery";
      params["site"] = site.value;
      params["oper"] = oper.value;
      methods.axiosAction(params).then(() => {
        let result = axiosResult.value;
        // console.log(result);

        let result_data = result.QueryTableData;
        if (path.value != result.page) {
          return;
        }
        if (site.value != result.QueryData.site) {
          return;
        }
        if (oper.value != result.QueryData.oper) {
          return;
        }
        //稽核模式：整組(廠區)旗標，給「未導入」(查無資料)機台的顯示用
        siteAuditMode.value = !!result.auditMode;
        let deviceDataKey = Object.keys(deviceData.value);
        if (deviceDataKey.length != result_data.length) {
          deviceData.value = {};
        }
        for (let i = 0; i < result_data.length; i++) {
          //稽核模式：離線機台暫時顯示為運作中，其他狀態不受影響
          //打頭/輾牙/熱處理查無訊號時用"-"(未導入)標記，包裝/裝櫃則可能是空字串，這裡一併視為離線
          if (
            result_data[i]["auditMode"] &&
            (result_data[i]["status"] == "S" ||
              result_data[i]["status"] == "-" ||
              !result_data[i]["status"])
          ) {
            result_data[i]["status"] = "R";
          }
          deviceData.value[result_data[i]["device_name"]] = result_data[i];
        }

        deviceDataKey = null;
        result = null;
        result_data = null;
        queryCounter.value++;
        getNowTime();
        setTimeout(function () {
          if (detail.value == true) {
            return;
          }
          getMachineData();
        }, 1000);
      });
    };

    //更新機台狀態
    watch(
      deviceData,
      () => {
        setElecboardStatus(sideBarSelect.value.oper);
      },
      {
        deep: true,
      }
    );

    // 監聽是否要看明細，若是總覽圖則初始化提醒標題
    watch(detail, (newValue) => {
      if (newValue == false) {
        initRealData();
        getMachineData();
      } else if (newValue == true) {
      } else {
        detail.value = false;
      }
    });
    // 紀錄查詢次數，超過1500次重新整理
    watch(queryCounter, (newValue) => {
      if (newValue > 1500) {
        window.location.reload();
      }
    });

    watch(sideBarSelect, (newValue) => {
      //重設製程及組別、清空機台與明細資料
      clearTimer();
      site.value = newValue.site.id;
      oper.value = newValue.oper.id;
      siteName.value = newValue.site.name;
      operName.value = newValue.oper.name;
      groupSelect.value = 0;
      setElecboardOper(newValue.oper); //清除並重設userArray、colCount、deviceArray
      setElecboardStatus(newValue.oper); //清除並重設totalDeviceStatus
      detail.value = null;
    });

    watch(groupSelect, (newValue) => {
      // if (newValue == 0) {
      //   return;
      // }
      //重設製程及組別、清空機台與明細資料
      clearTimer();
      setElecboardOper(sideBarSelect.value.oper);
      setElecboardStatus(sideBarSelect.value.oper);
      detail.value = null;
    });

    setTimeout(() => {
      //重設製程及組別、清空機台與明細資料
      clearTimer();
      site.value = sideBarSelect.value.site.id;
      oper.value = sideBarSelect.value.oper.id;
      siteName.value = sideBarSelect.value.site.name;
      operName.value = sideBarSelect.value.oper.name;
      groupSelect.value = 0;
      setElecboardOper(sideBarSelect.value.oper); //清除並重設userArray、colCount、deviceArray
      setElecboardStatus(sideBarSelect.value.oper); //清除並重設totalDeviceStatus

      //session資料
      const mesElecBoardDeviceName = sessionStorage.getItem(
        "mes-elecBoard-deviceName"
      );
      const mesElecBoardDetail = sessionStorage.getItem("mes-elecBoard-detail");
      const mesElecBoardTabIndex = sessionStorage.getItem(
        "mes-elecBoard-tabIndex"
      );
      sessionStorage.removeItem("mes-elecBoard-deviceName");
      sessionStorage.removeItem("mes-elecBoard-detail");
      sessionStorage.removeItem("mes-elecBoard-tabIndex");
      if (mesElecBoardDeviceName != null) {
        deviceName.value = mesElecBoardDeviceName;
      }
      if (mesElecBoardDetail != null) {
        detail.value = mesElecBoardDetail == "true" ? true : false;
      }
      if (mesElecBoardTabIndex != null) {
        tabIndex.value = mesElecBoardTabIndex;
      }
    }, 0);

    provide("site", site);
    provide("oper", oper);
    provide("siteName", siteName);
    provide("operName", operName);
    provide("deviceName", deviceName);
    provide("detail", detail);
    provide("userArray", userArray);
    provide("colCount", colCount);
    provide("deviceArray", deviceArray);
    provide("totalDeviceStatus", totalDeviceStatus);
    provide("deviceData", deviceData);
    provide("siteAuditMode", siteAuditMode);
    provide("tabIndex", tabIndex);
    provide("nowTime", nowTime);
    provide("groupSelect", groupSelect);
    provide("groupDevice", groupDevice);
    provide("groupList", groupList);

    onUnmounted(() => {
      window.removeEventListener("beforeunload", setSessionItems);
      clearTimer();
    });
    return { site, oper, detail };
  },
};
</script>

<style>
.mes-update-time {
  font-size: 1rem;
}
.elecBoard-main-title {
  color: var(--main-bg-color);
  font-size: 1.75rem;
  font-family: dfyuanstd-w8, dfyuanstd-w7;
}
.elecBoard-sub-title {
  background-color: var(--main-bg-color);
  color: var(--main-font-color);
  font-size: 1.5rem;
  font-family: dfyuanstd-w8, dfyuanstd-w7;
}
.elecBoard-oper-img img {
  height: 81px;
}
.elecBoard-user-name {
  color: var(--main-font-color);
  font-size: 1.125rem;
  font-family: dfyuanstd-w7, dfyuanstd-w5;
}
.elecBoard-row > div:nth-child(2) > div .common-col-card {
  border-left: none;
}
.elecBoard-row > div > div .common-col-card {
  border-bottom: none;
}
.elecBoard-row > div > div .common-col-card:last-child {
  border-bottom: 1px solid rgb(204, 204, 204);
}
.elecBoard-col-default {
  color: #cccccc;
}
.elecBoard-col-title-name-R {
  /* 運作 */
  background-color: var(--main-status-success-color);
  color: var(--main-font-color);
}
.elecBoard-col-title-name-Q {
  /* 待機 */
  background-color: var(--main-status-warning-color);
  color: var(--main-font-color);
}
.elecBoard-col-title-name-H {
  /* 異常 */
  background-color: var(--main-status-danger-color);
  color: var(--main-font-color);
}
.elecBoard-col-title-name-S {
  /* 關機 */
  background-color: var(--main-status-stop-color);
  color: var(--main-font-color);
}
.elecBoard-col-title-name-A {
  /* 校驗 */
  background-color: var(--main-status-shunting-color);
  color: var(--main-font-color);
}
.elecBoard-col-title-name-C {
  /* 換模 */
  background-color: var(--main-status-shunting-color);
  color: var(--main-font-color);
}
.elecBoard-col-title-name-M {
  /* 維修 */
  background-color: var(--main-status-maintain-color);
  color: var(--main-font-color);
}
.elecBoard-col-title-name-D {
  /* 調車 */
  background-color: var(--main-status-shunting-color);
  color: var(--main-font-color);
}
.elecBoard-col-title-name-I {
  /* 短寸 */
  background-color: var(--main-status-short-color);
  color: var(--main-font-color);
}
.elecBoard-col-title-name-E {
  /* 維修 */
  background-color: var(--main-status-maintain-color);
  color: var(--main-font-color);
}
.elecBoard-col-title-status-R {
  background-color: #f2f2f2;
  color: var(--main-status-success-color);
}
.elecBoard-col-title-status-Q {
  background-color: #f2f2f2;
  color: var(--main-status-warning-color);
}
.elecBoard-col-title-status-H {
  background-color: #f2f2f2;
  color: var(--main-status-danger-color);
}
.elecBoard-col-title-status-S {
  background-color: #f2f2f2;
  color: var(--main-status-stop-color);
}
.elecBoard-col-title-status-A {
  background-color: #f2f2f2;
  color: var(--main-status-shunting-color);
}
.elecBoard-col-title-status-C {
  background-color: #f2f2f2;
  color: var(--main-status-shunting-color);
}
.elecBoard-col-title-status-M {
  background-color: #f2f2f2;
  color: var(--main-status-maintain-color);
}
.elecBoard-col-title-status-D {
  background-color: #f2f2f2;
  color: var(--main-status-shunting-color);
}
.elecBoard-col-title-status-I {
  background-color: #f2f2f2;
  color: var(--main-status-short-color);
}
.elecBoard-col-title-status-E {
  background-color: #f2f2f2;
  color: var(--main-status-maintain-color);
}
.elecBoard-col-detail {
  overflow-x: auto;
}
.elecBoard-col-detail > div {
  white-space: nowrap;
}
.elecBoard-col-detail::-webkit-scrollbar {
  display: none;
}
.elecBoard-detail-button {
  width: 53px;
  height: 22px;
  line-height: 22px;
  padding: 0px;
  background-color: var(--main-bg-color);
  color: var(--main-font-color);
  border: 0px;
}
.elecBoard-detail-button:hover {
  color: var(--main-font-color);
}
.elecBoard-detail-button-default {
  background-color: #cccccc;
  pointer-events: none;
}
.elecBoard-progress-bar {
  height: 25px;
}
.elecBoard-progress-bar-R {
  background-color: var(--main-status-success-color);
}
.elecBoard-progress-bar-Q {
  background-color: var(--main-status-warning-color);
}
.elecBoard-progress-bar-H {
  background-color: var(--main-status-danger-color);
}
.elecBoard-progress-bar-S {
  background-color: var(--main-status-stop-color);
}
.elecBoard-progress-bar-A {
  background-color: var(--main-status-shunting-color);
}
.elecBoard-progress-bar-C {
  background-color: var(--main-status-shunting-color);
}
.elecBoard-progress-bar-M {
  background-color: var(--main-status-maintain-color);
}
.elecBoard-progress-bar-E {
  background-color: var(--main-status-maintain-color);
}

.elecBoard-progress-bar > span {
  white-space: nowrap;
  position: absolute;
  left: 2%;
  top: 50%;
  transform: translate(0%, -50%);
  color: #000;
  font-weight: bold;
  font-size: 20px;
}
.elecBoard-progress-bar > span.center {
  white-space: nowrap;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: #000;
  font-weight: bold;
  font-size: 20px;
}
.elecBoard-heat-col-title {
  width: 30%;
  margin-left: 0px !important;
}
.elecBoard-group-item {
  border: none;
  background: transparent;
  padding: 0;
  color: #aab3bb;
  text-decoration: underline;
}
.elecBoard-group-item.active {
  color: #0d6efd;
  text-decoration: none;
}
@media screen and (max-width: 1400px) {
  .elecBoard-oper-img {
    display: none;
  }
  .elecBoard-row > div:first-child > div .common-col-card:last-child {
    border-bottom: none;
  }
  .elecBoard-row > div:nth-child(2) > div .common-col-card {
    border-left: 1px solid rgb(204, 204, 204);
  }
}
@media (min-width: 992px) {
  .elecBoard-heat-col-title {
    width: 50%;
  }
}
@media (min-width: 768px) {
  .elecBoard-heat-col-title {
    width: 50%;
  }
}
@media screen and (min-width: 1400px) {
  .elecBoard-heat-col-title {
    width: 30%;
  }
}
</style>
<style lang="scss"></style>
